import { createSlice } from "@reduxjs/toolkit";
import { SectionEnum } from "../../common/enums/SectionEnum";

export interface QualificationDetailPageInterface {
    status: "active" | "expired";
    selectedCount: number;
    today: string;
    sortAchievedCertificates: {
        sortName: string;
        isSorted: boolean;
    };
    sortEducators: {
        sortName: string;
        isSorted: boolean;
    };
    sortEmployees: {
        sortName: string;
        isSorted: boolean;
    };
    isModalOpen: boolean;
    isFunctionGroupModalOpen: boolean;
    isQualificationStandardModalOpen: boolean;
    section: {
        name: SectionEnum;
        value: number;
    };
}

const initialState: QualificationDetailPageInterface = {
    status: "active",
    selectedCount: 0,
    today: new Date().toISOString(),
    sortAchievedCertificates: {
        sortName: "",
        isSorted: false,
    },
    isModalOpen: false,
    isFunctionGroupModalOpen: false,
    isQualificationStandardModalOpen: false,
    section: {
        name: SectionEnum.ACHIEVED_CERTIFICATES,
        value: 0,
    },
    sortEducators: {
        sortName: "",
        isSorted: false,
    },
    sortEmployees: {
        sortName: "",
        isSorted: false,
    },
};

const QualificationDetailSlice = createSlice({
    name: "dashboard",
    initialState,
    reducers: {
        setStatus: (state, action) => {
            state.status = action.payload;
        },
        setSortAchievedCertificates: (state, action) => {
            state.sortAchievedCertificates = action.payload;
        },
        setIsModalOpen: (state, action) => {
            state.isModalOpen = action.payload;
        },
        setIsFunctionGroupModalOpen: (state, action) => {
            state.isFunctionGroupModalOpen = action.payload;
        },
        setIsQualificationStandardModalOpen: (state, action) => {
            state.isQualificationStandardModalOpen = action.payload;
        },
        setSection: (state, action) => {
            state.section = action.payload;
        },
        setSortEducators: (state, action) => {
            state.sortEducators = action.payload;
        },
        setSortEmployees: (state, action) => {
            state.sortEmployees = action.payload;
        },
    },
});

export const qualificationDetailReducer = QualificationDetailSlice.reducer;
export const {
    setStatus,
    setSortAchievedCertificates,
    setIsModalOpen,
    setIsFunctionGroupModalOpen,
    setIsQualificationStandardModalOpen,
    setSection,
    setSortEducators,
    setSortEmployees,
} = QualificationDetailSlice.actions;
